import { render, staticRenderFns } from "./cookie-module-layout.vue?vue&type=template&id=1b7aa66a"
import script from "./cookie-module-layout.vue?vue&type=script&lang=js"
export * from "./cookie-module-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports